import { computed, inject, Injectable, signal } from '@angular/core';
import { EngagementGridContainerPage, EngagementType, StaffRoleId } from '@interfaces';
// import { DeliveryFollowUpsCommonService } from '../../../services';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';
import { DeliveryAreaService } from '../delivery-area.service';


/**
 * The list of tabs on this page
 */
export enum DeliveryEngagementsPageTabId {
	Tab1 = 1,
	Tab2 = 2,
}

/**
 * The list if main tab droplist views on this page
 */
export enum DeliveryEngagementsPageViewId {
	ContactReqs = 1,
	OpenEngagements = 2,
	CompletedEngagements = 3,
	FollowUps = 4,
}


@Injectable({ providedIn: 'root' })
export class DeliveryEngagementsService extends PageTabsLayoutPageService<DeliveryEngagementsPageTabId, DeliveryEngagementsPageViewId> {

	public readonly areaService = inject(DeliveryAreaService);
	public engagements = computed(() => this.areaService.deliveryData()?.engagements || []);
	public followUps = computed(() => this.areaService.deliveryData()?.followUps || []);
	public contactRequests = computed(() => this.areaService.deliveryData()?.contactRequests || []);
	public readonly page = signal<EngagementGridContainerPage>(EngagementGridContainerPage.Delivery);
	public engagementType = signal<EngagementType | undefined>(undefined);
	public readonly staffRoleId = signal<StaffRoleId | undefined>(StaffRoleId.ProgramFacilitator);
	private static readonly _viewDroplistItems: DroplistItem<never, DeliveryEngagementsPageViewId>[] = [
		{
			uniqueId: DeliveryEngagementsPageViewId.ContactReqs, iconContext: {
				iconClass: 'fa-envelope-dot',
				iconStyle: 'fa-solid',
				text: 'Contact Requests',
				hideText: 'never',
			},
			customSort: '1-Views-1'
		},
		{
			uniqueId: DeliveryEngagementsPageViewId.OpenEngagements, iconContext: {
				iconClass: 'fa-message-arrow-up-right',
				iconStyle: 'fa-solid',
				text: 'Open Engagements',
				hideText: 'never',
			}, customSort: '1-Views-2'
		},
		{
			uniqueId: DeliveryEngagementsPageViewId.CompletedEngagements, iconContext: {
				iconClass: 'fa-message-check',
				iconStyle: 'fa-solid',
				text: 'Completed Engagements',
				hideText: 'never',
			},
			customSort: '1-Views-3'
		},
		{
			uniqueId: DeliveryEngagementsPageViewId.FollowUps, iconContext: {
				iconClass: 'fa-reply-clock',
				iconStyle: 'fa-solid',
				text: 'Scheduled Follow Ups',
				hideText: 'never',
			},
			customSort: '1-Views-4'
		},
	];

	constructor() {
		super(DeliveryEngagementsService._viewDroplistItems, DeliveryEngagementsService.name, DeliveryEngagementsPageTabId.Tab1, DeliveryEngagementsPageViewId.OpenEngagements);
	}

	public get viewId() {
		return DeliveryEngagementsPageViewId;
	}


	async reloadData() {
		await this.areaService.reloadData();
	}
}
